import Map from "ol/Map";
import React from "react";

const MapContext = React.createContext<{
  map?: Map;
  zoom?: number;
  setZoom?: React.Dispatch<React.SetStateAction<number | undefined>>;
  center?: number[];
  setCenter?: React.Dispatch<React.SetStateAction<number[] | undefined>>;
  resetZoom?: Function;
}>({});
export default MapContext;
